<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf=" (mode !== 'view' && mode !== 'view2') || mode=='mode'">
  <div class="row">
    <div class="col-md-3 text-align-left">
      <label for="firstName" class="label-color"> {{field.Title}}</label>
    </div>
    <div class="col-md-4">
      <div class="row">
        <div class="col-md-5">
          <div class="date-form">
            <input class="form-control" placeholder="Date" [minDate]="minDate" [maxDate]="maxDate" (ngModelChange)="onChange2($event)"
                   name="dp2" [(ngModel)]="SelectedDate" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
            <small class="form-text text-danger"
                   *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
            <a (click)="d2.toggle()" class="nav-link-hand">
              <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

            </a>

          </div>
        </div>
        <div class="col-md-6">
          <label class="margin-bottom-0px margin-top-6px">({{field.Value| date:'MMM-dd-yyyy'}})</label>
        </div>
      </div>


    </div>

  </div>

</div>
<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="mode=='view'">
  <div class="row">
    <div class="col-md-3 text-align-left">
      <label for="firstName" class="label-color"> {{field.Title}}</label>
    </div>
    <!--<div class="col-md-1 font-weight-bold margin-top-5px">
      :
    </div>-->
    <div class="col-md-4">

      <!--<div class="date-form">
        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
               name="dp2" [(ngModel)]="field.Value" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
        <small class="form-text text-danger"
               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
        <a (click)="d2.toggle()" class="nav-link-hand">
          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

        </a>

      </div>-->
      <label class="margin-bottom-0px font-weight-normal">{{field.Value |date:'MMM-dd-yyyy'}}</label>

    </div>

  </div>

</div>
<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="mode=='view2'">
  <div class="row font-size-14">
    <div class="col-md-3 text-align-left">
      <label for="firstName" class="label-color"> {{field.Title}}</label>
    </div>
    <!--<div class="col-md-1 font-weight-bold margin-top-5px">
      :
    </div>-->
    <div class="col-md-4">

      <!--<div class="date-form">
        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
               name="dp2" [(ngModel)]="field.Value" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
        <small class="form-text text-danger"
               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
        <a (click)="d2.toggle()" class="nav-link-hand">
          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

        </a>

      </div>-->
      <label class="margin-bottom-0px font-weight-normal">{{field.Value |date:'MMM-dd-yyyy'}}</label>

    </div>

  </div>

</div>
